// mds-dojo — dojo/_base/window — faithful port of references/dojo/_base/window.js.
// Save/set/restore of the global/document scope. The IE/quirks re-detection inside
// withDoc is dropped (no IE support); the scope-shifting contract is preserved.
import dojo from './kernel';
import lang from './lang';

const ret: any = {
  global: dojo.global,
  doc: dojo.global['document'] || null,

  body(doc?: any): any {
    // Return the body element of the specified document (or dojo.doc).
    doc = doc || dojo.doc;
    return doc.body || doc.getElementsByTagName('body')[0];
  },

  setContext(globalObject: any, globalDocument: any): void {
    dojo.global = ret.global = globalObject;
    dojo.doc = ret.doc = globalDocument;
  },

  withGlobal(globalObject: any, callback: any, thisObject?: any, cbArguments?: any): any {
    const oldGlob = dojo.global;
    try {
      dojo.global = ret.global = globalObject;
      return ret.withDoc.call(null, globalObject.document, callback, thisObject, cbArguments);
    } finally {
      dojo.global = ret.global = oldGlob;
    }
  },

  withDoc(documentObject: any, callback: any, thisObject?: any, cbArguments?: any): any {
    const oldDoc = ret.doc;
    try {
      dojo.doc = ret.doc = documentObject;
      if (thisObject && typeof callback == 'string') {
        callback = thisObject[callback];
      }
      return callback.apply(thisObject, cbArguments || []);
    } finally {
      dojo.doc = ret.doc = oldDoc;
    }
  },
};

lang.mixin(dojo, ret);

export default ret;
